import axios from 'axios';
import apisUrls from '../urls';

const getAllClientsApi = (paramsFilter) => {
  return axios.get(apisUrls?.getClients(paramsFilter));
};

export default getAllClientsApi;
